import type { SVGProps } from "react";
import * as React from "react";

const SvgIconSlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <path
      fill="#2EB67D"
      d="M62.315 35.147a5.859 5.859 0 1 0-5.86-5.858v5.858zm-16.407 0a5.86 5.86 0 0 0 5.86-5.859V12.883a5.86 5.86 0 0 0-11.72 0v16.405a5.86 5.86 0 0 0 5.86 5.86"
    />
    <path
      fill="#E01E5A"
      d="M13.095 39.835a5.859 5.859 0 1 0 5.86 5.858v-5.858zm16.407 0a5.86 5.86 0 0 0-5.86 5.86V62.1a5.86 5.86 0 1 0 11.72 0V45.694a5.86 5.86 0 0 0-5.86-5.859"
    />
    <path
      fill="#ECB22E"
      d="M40.05 62.101a5.859 5.859 0 1 0 5.858-5.86h-5.859zm0-16.407a5.86 5.86 0 0 0 5.859 5.86h16.405a5.86 5.86 0 0 0 0-11.719H45.909a5.86 5.86 0 0 0-5.86 5.86"
    />
    <path
      fill="#36C5F0"
      d="M35.36 12.881a5.859 5.859 0 1 0-5.858 5.86h5.859zm0 16.407a5.86 5.86 0 0 0-5.859-5.86H13.096a5.86 5.86 0 0 0 0 11.72h16.405a5.86 5.86 0 0 0 5.86-5.86"
    />
  </svg>
);
export default SvgIconSlack;
